import { render, staticRenderFns } from "./PanelButton.vue?vue&type=template&id=92ef0b0a"
import script from "./PanelButton.vue?vue&type=script&lang=js"
export * from "./PanelButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports